// modules分成不同功能的模块
import Vue from 'vue';
import * as types from '../mutation-types.js';

const state = {
  alarmFilterList: []
};


const getters = {
  alarmFilterList: state => state.alarmFilterList
};

const mutations = {
  [types.GET_ALARMFILTERLIST](state, res) {
    const fliterObj = {};
    for (const key in res) {
      fliterObj[key] = [];
      for (const sonKey in res[key]) {
        if (key == 'status' || key == 'strategyStatus') {
          const obj = {
            text: res[key][sonKey],
            value: sonKey
          };
          fliterObj[key].unshift(obj);
        } else {
          const obj = {
            text: res[key][sonKey],
            value: sonKey
          };
          fliterObj[key].push(obj);
        }

      }
    }
    state.alarmFilterList = fliterObj;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/alarmFilters.js